import { Link } from 'react-router-dom';
import { Tooltip, TooltipContent, TooltipTrigger } from '../ui/tooltip';

const BADGE_STYLE = {
  IA: 'bg-emerald-500/15 text-emerald-700 dark:text-emerald-400',
  LIVE: 'bg-blue-500/15 text-blue-700 dark:text-blue-400 animate-pulse',
  EMR: 'bg-purple-500/15 text-purple-700 dark:text-purple-400',
};

export const SidebarItem = ({ mod, active, collapsed, onNavigate }) => {
  const Icon = mod.icon;
  const link = (
    <Link
      to={mod.href}
      onClick={onNavigate}
      aria-current={active ? 'page' : undefined}
      className={`group flex items-center gap-3 rounded-lg text-sm font-medium transition-colors duration-150
        ${collapsed ? 'justify-center px-0 py-2.5' : 'px-3 py-2'}
        ${active
          ? 'bg-[hsl(var(--lifeport-red))]/10 text-[hsl(var(--lifeport-red))] border-l-2 border-[hsl(var(--lifeport-red))]'
          : 'text-muted-foreground hover:bg-muted hover:text-foreground border-l-2 border-transparent'}`}
      data-testid={`nav-${mod.id}`}
    >
      <Icon className="h-[18px] w-[18px] flex-shrink-0" />
      {!collapsed && <span className="flex-1 truncate">{mod.label}</span>}
      {!collapsed && mod.badge && (
        <span className={`text-[10px] px-1.5 py-0.5 rounded-full flex-shrink-0 ${BADGE_STYLE[mod.badge] || 'bg-muted'}`}>{mod.badge}</span>
      )}
    </Link>
  );
  if (!collapsed) return link;
  return (
    <Tooltip delayDuration={0}>
      <TooltipTrigger asChild>{link}</TooltipTrigger>
      <TooltipContent side="right">{mod.label}</TooltipContent>
    </Tooltip>
  );
};
